/**
 * Shared visual style for every device ghost preview (the translucent shapes shown
 * while CSG geometry recomputes). Centralized so the look stays consistent and can be
 * tuned globally in one place — tweak these to make ghosts more/less prominent.
 */

/** Primary ghost tint — vivid blue so the preview reads clearly over any device color */
export const GHOST_COLOR = 0x1e9bff
/** Secondary tint for the front-face inner panel ghost (vivid green) */
export const GHOST_INNER_COLOR = 0x1fe07a
/** Tint for features being removed (vivid red) */
export const REMOVED_COLOR = 0xff3b30
/** Opacity for thin overlay ghosts (side-edge features, front-face features, decals) */
export const GHOST_OPACITY = 0.6
/** Opacity for the solid full-body ghost */
export const GHOST_BODY_OPACITY = 0.85
